import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';

import { useAppSelector } from '@/redux/hooks';
import { getRelatedSearchSuggestions } from '@/redux/modules/search/relatedSearches/relatedSearches.selectors';

import { SuggestionChip } from './SuggestionChip';

export const RelatedSearchesSuggestions = () => {
    const suggestions = useAppSelector(getRelatedSearchSuggestions);

    if (suggestions.length === 0) {
        return null;
    }

    const cards = suggestions.map((suggestion, index) => ({
        card: (
            <SuggestionChip
                position={index + 1}
                suggestion={suggestion}
            />
        ),
        key: suggestion.query,
    }));

    return (
        <div
            className="mb-md flex min-w-0 items-center gap-md [&_[class*='gap-']]:gap-xs [&_[class*='mt-sm']]:mt-0"
            data-testid="related-searches-suggestions"
        >
            <p className="hui-text-label-strong hidden shrink-0 smMin:block">
                <FormattedMessage id="searchPage.relatedSearchesLabel" />:
            </p>
            <div className="min-w-0 flex-1 [&_[role='list']]:pb-[1px]">
                <Carousel
                    cards={cards}
                    useOverlayControls
                />
            </div>
        </div>
    );
};
